const globals = {
  boxShadowSizes: {
    none: '0px 0px 0px',
    normal: '4px 4px 0px',
    large: '12px 12px 0px'
  },
  zIndex: {
    overlay: 500,
    modal: 700
  }
};

export { globals as default, globals };
//# sourceMappingURL=Globals.js.map
